import React from 'react';
import FormDialog from '../../../../library/form/components/FormDialog';
import withView from '../../../cmn/docAutomation/withView';
import FormInput from '../../../../library/form/components/FormInput';
import FormLabel from '../../../../library/form/components/FormLabel';
import FormRichText from '../../../../library/form/components/FormRichText';
import FormTitle from '../../../../library/form/components/FormTitle';
import FormSH from '../../../../library/form/components/FormSH';
import FormROValue from '../../../../library/form/components/FormROValue1';

const VoucherShorthand = (props) => {
    const { formObject, viewData, ...restProps } = props;

    if (!viewData)
        return (null)

    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true} formObject={formObject}
        action={{ formActions: { forAction: "Confirm", forCancel: "Cancel" }, actionParam:{showModeID:'sh'}}} contentStyle={{ height: '450px' }}
            formStyle={{ width: '750px' }} formTitle={<FormTitle formObject={formObject} value="New : collection" />}
        >  
            <div className="uiEditableContent">
                <div className="uiRow">
                    <div className="uiCol">
                        <ul>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "docID" }} value="" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "docID" }} className="uiValue" />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "profile" }} value="" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "profile" }} className="uiValue" />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "paymentMode" }} value="Payment Mode" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiVal"
                                    action={{ InputType: "ac", paramName: "paymentMode", acMethod: "CategoryDetail", acDepCtrl: { 'dparam': "%dataList.valLCat" } }}
                                />
                                <FormSH formObject={formObject} rowKey=""
                                    action={{ actionId: "new", paramName: "paymentMode",  actionName: "catDetail", actionParam: {}, containerKey: "popup" }}
                                     ></FormSH>
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "paymentDtl" }} value="Payment Detail" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiVal"
                                    action={{ InputType: "input", paramName: "paymentDtl" }}
                                />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "chargeType" }} value="Charge Type" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiInput"
                                    action={{ InputType: "ac", actionId:"refresh", paramName: "chargeType", acMethod: "CategoryDetail", acDepCtrl: { 'dparam': "%dataList.valLCat" },actionParam:{updateOutstanding:"1", showModeID:'sh'} }}
                                />
                               
                                <FormSH formObject={formObject} rowKey="" 
                                    action={{ actionId: "new", paramName: "chargeType",  actionName: "catDetail", actionParam: {}, containerKey: "popup" }}
                                />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "chargePercent" }} value="Charge %" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiVal"
                                    action={{ InputType: "input", actionId:"refresh", paramName: "chargePercent", actionParam:{updateOutstanding:"1",showModeID:'sh' } }}
                                />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "refNumber" }} value="Reference Number" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiVal"
                                    action={{ InputType: "input", paramName: "refNumber" }}
                                />
                            </li>
                        </ul>
                    </div>
                    <div className="uiCol">
                        <ul>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "voucherDate" }} value="Voucher Date" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiVal" action={{ InputType: "dp", paramName: "voucherDate" }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "currency" }} value="Currency" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className=""
                                    action={{ InputType: "ac", actionId:"refresh", paramName: "currency", acMethod: "CurrencyName", acDepCtrl: { 'dparam': "%dataList.valLCat" },actionParam:{updateOutstanding:"1"} }}
                                />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "exRate" }} value="Exchange Rate" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className=""
                                    action={{ InputType: "input", paramName: "exRate" }}
                                />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "voucherAmt" }} value="Voucher Amount" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiVal"
                                    action={{ InputType: "input", actionId:"refresh", paramName: "voucherAmt", actionParam:{updateOutstanding:"1"} }}
                                />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "taxDeducted" }} value="Tax Deducted" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiVal"
                                    action={{ InputType: "input", paramName: "taxDeducted" }}
                                />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "chargeAmount" }} value="Charge Amount" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiVal"
                                    action={{ InputType: "input", actionId:"refresh", paramName: "chargeAmount", actionParam:{updateOutstanding:"1"} }}
                                />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "amtToAdjust" }} value="Amount to Adjust" />
                                </span>
                                <FormROValue formObject={formObject} rowKey="" action={{ paramName: "amtToAdjust" }} className="uiVal" />
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="uiRow">
                    <span className="uiLbl">
                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "remarks" }} value="Remarks" />
                    </span>
                    <FormRichText formObject={formObject} rowKey="" rows="3" cols="71" className="uiFrmText" action={{ paramName: "remarks" }} />
                </div>
                <div className="uiRow" ID="outstandingAmtDateEditor" >
                    <div className="uiColumn uiROHeader uiSpacer15">
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "lastPaidOn" }} value="Last Paid Date" />
                        </span>
                        <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "lastPaidOn" }} className="uiValue" />

                        <span className="uiLblInLine">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "totalOutstanding" }} value="Total Outstanding" />
                        </span>
                        <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "totalOutstanding" }}  />

                        <span className="uiLblInLine">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "orderOutstanding" }} value="Order Outstanding" />
                        </span>
                        <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "orderOutstanding" }}  />
                    </div>
                </div>
            </div>
        </FormDialog>
    )
}

export default withView(VoucherShorthand, "voucherComp", "invTrans,invTrnFooter")